export const SbscomRoutes = [
  {
    path: '/deals',
    name: 'Deals',
    component: () =>
      import(
        /* webpackChunkName: "lp-urlaubsguru" */ /* webpackPreload: true */ '../views/Landingpages/Sbscom/Deals.vue'
      ),
    meta: {
      breadcrumb: 'Deals',
    },
  },
  {
    path: '/suedtirol',
    name: 'suedtirol',
    component: () =>
      import(
        /* webpackChunkName: "lp-sbscom" */ /* webpackPreload: true */ '../views/Landingpages/Sbscom/Suedtirol.vue'
      ),
    meta: {
      breadcrumb: 'Südtirol',
    },
  },
]
